import React, { Component } from 'react';
import Button from 'shared/lib/components/Button';
import OrRule from '../../components/OrRule';
import PropTypes from 'prop-types';
import * as analytics from 'shared/lib/analytics';
import './ClaimsContact.css';

const propTypes = {
  phoneNumber: PropTypes.string,
  orders: PropTypes.object,
};

const defaultProps = {
  phoneNumber: '+1 (844) 335-5441',
  orders: {},
};

class ClaimsContact extends Component {
  componentDidMount() {
    document.title = `Claims | Contact Info - Sure`;
    analytics.page('Portal - Claim Contact Support', {
      category: 'claim',
    });
  }

  handleContactSupportClick() {
    analytics.track('Portal - Claims Contact Support Clicked', {
      category: 'user',
    });
  }

  handleCallUsClicked() {
    analytics.track('Portal - Claims Call Us Clicked', {
      category: 'user',
    });
  }

  render() {
    const { phoneNumber } = this.props;

    return (
      <div className="ClaimsContact">
        <div className="Container Container--small">
          <h1 className="ClaimsContact-heading">Start A Claim</h1>
          <p className="ClaimsContact-info">
            Our in-house support staff is here to help with any of your
            questions.
          </p>
          <div className="ClaimsContact-options">
            <Button
              href="http://support.sureapp.com/hc/requests/new"
              onClick={this.handleContactSupportClick}
            >
              Contact our support team
            </Button>
            <OrRule />
            <Button
              href={'tel:' + phoneNumber}
              onClick={this.handleCallUsClicked}
            >
              Call us {phoneNumber}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

ClaimsContact.propTypes = propTypes;
ClaimsContact.defaultProps = defaultProps;

export default ClaimsContact;
